import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import { getItem } from '@/utils/storage-main'
import { getLang } from '@/utils/storage'
import handleSaveAndJump from '@/utils/saveLogin.js'
import axios from 'axios'
import { gotinTrack } from '@frontend/gotin-track'
import { isMobileWechat } from '@/utils'
import { isUnderWhiteList } from '@/utils/whiteList.js'
import { getBusinessType } from '@/constant'
import { handleThirdParams } from '@/utils/mutiple.js'
import EnumInfo from '@/enum'

Vue.use(Router)
const router = new Router({
  routes,
  base: process.env.BASE_URL,
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

// 刷新token之后直接跳走
// 两种情况
// 第一种；用户未登录：走正常登录拿到token并保存
// 第二种：某个业务端登录以后，其他业务端在去登录这个时候会刷新token重新登录
// 业务端：token过期后并不需要去登录中心刷新token，将token相关的内容封装成sdk
const handleRefreshToken = async () => {
  const expireTime = getItem('expired_time')
  if (getItem('Authorization') && expireTime) {
    const now = Date.now()
    if (now > expireTime) {
      const userHash = getItem('userhash')
      const refreshToken = getItem('refresh_token')
      if (userHash && refreshToken) {
        const data = {
          hash: userHash,
        }
        axios
          .post('/web/user/refresh', null, {
            params: data,
            headers: {
              'X-Ca-Nonce': Math.random().toString(36).substr(2, 15),
              'X-Ca-Timestamp': +new Date(),
              'X-I18n-Language': { en: 'en-US', cn: 'zh-CN' }[getLang()],
              Method: 'post',
              Refresh_Token: refreshToken,
            },
            baseURL: process.env.VUE_APP_AUTH_URI,
          })
          .then(async (res) => {
            handleSaveAndJump(res.data.data)
          })
          .catch((err) => {
            //处理token过期的情况
            console.log(err)
          })
      }
    }
  }
}

handleRefreshToken()

router.beforeEach(async (to, from, next) => {
  const { name, alias, gi_guest, redirect_url, enter } = to.query
  // 嘉宾邀请（其实可以在发送邮件的时候就直接拼成url，路由拦截处理成常规的带redirect_url）
  if (!redirect_url && alias && gi_guest) {
    const goUrl =
      alias && gi_guest
        ? `https://${alias}${process.env.VUE_APP_LOGIN_DOMAIN}`
        : ''
    to.query.redirect_url = goUrl
  }

  // 处理回调地址合法性
  if (redirect_url) {
    if (await isUnderWhiteList(redirect_url)) {
      // 处理微信相关
      if (
        isMobileWechat() &&
        !EnumInfo.includes(enter) &&
        to.name !== 'personalInfo' &&
        getBusinessType() &&
        getBusinessType().needSlientLogin // 不需要静默获取openid
      ) {
        handleThirdParams(name, redirect_url, next)
      } else {
        next()
      }
    } else {
      if (to.path === '*') {
        next()
      } else {
        next({ path: '*' })
      }
    }
  } else {
    next()
  }
})

// 捕获pageName用到
router.afterEach((to) => {
  gotinTrack.updatePageInfo(to)
  window.closeSkeleton() // 关闭骨架屏
})

export default router
